import React from 'react'
import Style from './UserInfoAddress.module.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEarth } from '@fortawesome/free-solid-svg-icons'
const UserInfoAddress = ({title,info,type}) => {
    const OpenMapHandler = (location) => {
    window.open(
      `https://maps.apple.com/?q=${info.lat},${info.lon}`
    );
  };
  return (
  <fieldset className={Style.fieldSetHolder}>
    <legend>{title}</legend>
    <div>
        <label htmlFor="">{`نام ${type}:`}</label>
        <span>{info?.name}</span>
    </div>
    <div>
        <label htmlFor="">{`شماره ${type}:`}</label>
        <span>{info?.phone}</span>
    </div>
    <div>
        <label htmlFor="">{`توضیحات ${type}:`}</label>
        <span>{info?.routes_description}</span>
    </div>
        <div>
        <label htmlFor="">{`موقعیت روی نقشه ${type}:`}</label>
        <strong onClick={OpenMapHandler}>کلیک کنید<FontAwesomeIcon icon={faEarth}/></strong>
    </div>
    <div>
        <label htmlFor="">{`آدرس ${type}:`}</label>
        <span>{info?.description}</span>
    </div>

    
  </fieldset>
  )
}

export default UserInfoAddress